import { defineMessages } from 'react-intl';

export const scope = 'app.components.exams';

export default defineMessages({
  empty_record_title: {
    id: `${scope}.empty_search_list`,
    defaultMessage: 'No Results Found',
  },
  empty_record_description: {
    id: `${scope}.empty_record_description`,
    defaultMessage: "Sorry, we couldn't find any matches. Please try again.",
  },
  empty_exam: {
    id: `${scope}.empty_exam`,
    defaultMessage: 'Exams Will Appear Here',
  },
  empty_exam_description: {
    id: `${scope}.empty_exam_description`,
    defaultMessage: 'Contact support for assistance.',
  },
});
